import { Box } from "@chakra-ui/react";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import CheckoutPage from "../CheckoutPage/CheckoutPage";
import useIsActiveOnPage, { PagePurpose } from "../../hooks/useIsActiveOnPage";

const Content = () => {
  const { activePage, isSidebarSticked } = useAppSelector(selectAppState);
  const isCheckoutPageAccessible = useIsActiveOnPage(PagePurpose.CHECKOUT_PAGE_ACCESSIBLE, activePage!);

  const getPageContent = () => {
    if (isCheckoutPageAccessible) {
      return <CheckoutPage />;
    }

    return <></>;
  };

  const paddingValue = `${!isSidebarSticked ? "80px" : "256px"}`;

  return (
    <>
      <Box
        sx={{
          bg: "neutrals.50",
          w: "100%",
          h: "100%",
          pl: paddingValue,
        }}
      >
        {getPageContent()}
      </Box>
    </>
  );
};

export default Content;
